"use client";

import { Card, Carousel, Tag } from "antd";
import { SHOP_URL } from "./shopUrl";

const { Meta } = Card;

interface Product {
    title: string;
    description: string;
    /** Gross price (PDV included), as shown on the shop. */
    price: string;
    /** Product slug on the shop; the page and image URLs derive from it. */
    slug: string;
    isNew?: boolean;
}

// Prices and slugs follow the shop catalog (Edu-Robo/shop, data/master/catalog.yaml).
const products: Product[] = [
    {
        title: "LEGO® Education Computing & AI set 5+",
        description: "Uvod u programiranje i umjetnu inteligenciju za najmlađe",
        price: "398,00 €",
        slug: "lego-education-computing-ai-5-plus",
        isNew: true,
    },
    {
        title: "LEGO® Education Computing & AI set 8+",
        description: "Računalstvo i umjetna inteligencija za 3. do 5. razred",
        price: "498,00 €",
        slug: "lego-education-computing-ai-8-plus",
        isNew: true,
    },
    {
        title: "LEGO® Education Computing & AI set 11+",
        description: "Računalstvo i umjetna inteligencija za 6. do 8. razred",
        price: "598,00 €",
        slug: "lego-education-computing-ai-11-plus",
        isNew: true,
    },
    {
        title: "LEGO® Education SPIKE™ Prime set",
        description: "Robotski set za programiranje za 6. do 8. razred",
        price: "539,00 €",
        slug: "lego-education-spike-prime",
    },
    {
        title: "LEGO® Education SPIKE™ Essential Set",
        description: "Robotski set za programiranje za 1. do 5. razred",
        price: "399,00 €",
        slug: "lego-education-spike-essential",
    },
    {
        title: "LEGO® Education SPIKE™ Prime Expansion Set v2",
        description: "Proširenje za SPIKE Prime za robotička natjecanja",
        price: "170,00 €",
        slug: "lego-education-spike-prime-expansion-set",
    },
    {
        title: "LEGO® Education Science 5+",
        description: "Prirodoslovlje i tehnologija za najmlađe",
        price: "369,00 €",
        slug: "lego-education-science-5-plus",
    },
    {
        title: "LEGO® Education Science 8+",
        description: "Prirodoslovlje i tehnologija za 3. do 5. razred",
        price: "469,00 €",
        slug: "lego-education-science-8-plus",
    },
    {
        title: "LEGO® Education Science 11+",
        description: "Prirodoslovlje i tehnologija za 6. do 8. razred",
        price: "569,00 €",
        slug: "lego-education-science-11-plus",
    },
];

const productUrl = (product: Product) =>
    `${SHOP_URL}/proizvodi/${product.slug}`;
const productImage = (product: Product) =>
    `${SHOP_URL}/images/products/${product.slug}-1.webp`;

const ProductCard = ({ product }: { product: Product }) => (
    <div>
        <Card
            hoverable
            style={{
                width: "100%",
                margin: "0 auto",
                minHeight: "350px",
            }}
            cover={
                <div style={{ position: "relative" }}>
                    <img
                        alt={product.title}
                        src={productImage(product)}
                        style={{
                            height: 200,
                            objectFit: "contain",
                            backgroundColor: "white",
                            width: "100%",
                            display: "block",
                        }}
                    />
                    {/* Kept inside the cover: the carousel clips anything past the slide edge */}
                    {product.isNew && (
                        <Tag
                            color="volcano"
                            variant="solid"
                            style={{
                                position: "absolute",
                                top: 8,
                                right: 8,
                                marginInlineEnd: 0,
                            }}
                        >
                            Novo
                        </Tag>
                    )}
                </div>
            }
            onClick={() => {
                window.open(
                    productUrl(product),
                    "_blank",
                    "noopener,noreferrer",
                );
            }}
        >
            <Meta
                title={
                    // Wrap instead of truncating, so the age variants stay distinguishable
                    <div style={{ whiteSpace: "normal" }}>{product.title}</div>
                }
                description={
                    <div>
                        <div style={{ marginBottom: "8px" }}>
                            {product.description}
                        </div>
                        <div
                            style={{
                                fontSize: "18px",
                                fontWeight: "bold",
                                color: "#52c41a",
                                textAlign: "right",
                            }}
                        >
                            {product.price}
                        </div>
                    </div>
                }
            />
        </Card>
    </div>
);

export default function ProductCarousel() {
    return (
        <div
            style={{
                width: "100%",
                minHeight: "400px",
                position: "relative",
            }}
        >
            <style
                dangerouslySetInnerHTML={{
                    __html: `
                .custom-carousel .slick-prev:before,
                .custom-carousel .slick-next:before {
                    color: #7cbbf5 !important;
                    font-size: 20px !important;
                }
                .custom-carousel .slick-prev,
                .custom-carousel .slick-next {
                    z-index: 10 !important;
                    color: #7cbbf5 !important;
                }
                .custom-carousel .slick-prev:hover,
                .custom-carousel .slick-next:hover {
                    color: #4096ff !important;
                }
                .custom-carousel .slick-prev:hover:before,
                .custom-carousel .slick-next:hover:before {
                    color: #4096ff !important;
                }
                .custom-carousel .slick-arrow {
                    color: #7cbbf5 !important;
                }
                .custom-carousel .slick-arrow:hover {
                    color: #4096ff !important;
                }
                .custom-carousel .slick-dots li button {
                    background: #7cbbf5 !important;
                }
                .custom-carousel .slick-dots li.slick-active button {
                    background: #4096ff !important;
                }
                `,
                }}
            />
            <Carousel
                arrows
                dots
                autoplay
                autoplaySpeed={4000}
                style={{ width: "100%" }}
                className="custom-carousel"
            >
                {products.map((product, index) => (
                    <div key={index}>
                        <ProductCard product={product} />
                    </div>
                ))}
            </Carousel>
        </div>
    );
}
